import { useMsal } from "@azure/msal-react";
import { getQueryState } from "lib/common/query-state";
import { useQuery } from "react-query";
import { IUserProps, IUseUserQueryResult } from "./interfaces";
import { getUser } from "services/security";

export function useUserQuery({ userId, enabled: queryEnabled = true }: IUserProps): IUseUserQueryResult {
  const { instance } = useMsal();

  const query = useQuery(
    ["user", userId],
    async () => await getUser(instance, { userId }),
    { enabled: !!userId && queryEnabled }
  );

  const user = query.data?.data;
  const etag = query.data?.headers?.etag;

  return {
    state: getQueryState(query.status),
    query,
    user,
    etag
  };
}

